<script setup>

import FieldsTableRow from '../FieldsTableRow.vue'
import {computed, ref, watch} from "vue";
import { store } from "@/store";

const props = defineProps({
  saving: Object,
  calculating: Boolean,
})
const emit = defineEmits(['calcDone'])
const inputSavingValue = ref(0)
const propCalculating = computed(() => {
  return props.calculating;
})
watch(inputSavingValue, () => {
  checkValid()
}) // Check input validity when value changes
watch(propCalculating, (newVal) => {
  if (newVal) calculateSaving()
}) // Do the calculation
const checkValid = () => {
  props.saving.valid = (parseInt(inputSavingValue.value) > 0);
}
const calculateSaving = () => {
  props.saving.valueAnnual = parseInt(inputSavingValue.value) / store.formData.user.annuityRate;
  props.saving.valueWeekly = props.saving.valueAnnual / 52;
  emit('calcDone');
}
</script>

<template>
  <FieldsTableRow
      v-bind:label="`Please enter the estimated total value at ${store.formData.user.sra} of any other DC retirement savings you have`">
    <input v-model="inputSavingValue" type="number" min="0" step="1" :disabled="props.calculating">
  </FieldsTableRow>
  <FieldsTableRow v-bind:justText="true">
    Don’t forget, if you plan to take some of your DC retirement savings as a cash sum you will need to deduct this
    amount from the total estimated value of your Personal Account.
  </FieldsTableRow>
</template>
